export const SubroFeaStatCodes = {
  Open: "1",
  Closed: "2",
  OnHold: "0",
};
